import store from "../../redux/store";
import api from "../axios";

export async function createOrder(itens, valor_orgadots = 0) {
  // get id_user from redux store
  const id_user = await store.getState().authReducer.user.id;

  let payload = {
    id_user,
    valor_orgadots,
    itens: itens.map((item) => {
      return {
        id_produto: item.id,
        quantidade: item.quantidade,
        id_variante: item.id_variante || null,
      };
    }),
  };
  try {
    let response = await api.post("/orders", payload);
    return response.data;
  } catch (error) {
    console.error("Error creating order:", error);
    // propaga a mensagem do backend (ex.: quantidade minima) para o toast
    throw new Error(
      error.response?.data?.error || error.message || "Erro ao criar pedido"
    );
  }
}

export async function getUserOrders(id_user) {
  id_user = id_user || (await store.getState().authReducer.user.id);
  try {
    let response = await api.post(`/orders/all`, { id_user });
    return response.data;
  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
}

export async function getOrderById(id) {
  try {
    let response = await api.get(`/orders/one/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching order by ID:", error);
    throw error;
  }
}

export async function getAllOrdersByManager(
  page = 1,
  perPage = 10000,
  filters = {},
  managerId
) {
  try {
    if (!managerId) {
      managerId = store.getState().authReducer.user.id;
    }
    let response = await api.post(`/orders/manager/all/${managerId}`, {
      page,
      perPage,
      filters,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching all orders:", error);
    throw error;
  }
}

export async function getAllOrders(page = 1, perPage = 10000, filters = {}) {
  try {
    let response = await api.post(`/orders/all`, {
      page,
      perPage,
      filters,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching all orders:", error);
    throw error;
  }
}

export async function declineOrder(id, reason) {
  try {
    let response = await api.post(`/orders/${id}/decline`, {
      reason,
    });
    return response.data;
  } catch (error) {
    console.error("Error declining order:", error.response?.data?.error);
    throw new Error(error.response?.data?.error || "Error ao cancelar pedido");
  }
}

export async function registrarEntrada(centro_de_custo, id) {
  try {
    let response = await api.post(`/orders/manager/set-created`, {
      centro_de_custo,
      id,
    });
    return response.data;
  } catch (error) {
    console.error("Error registering entry:", error.response?.data?.error);
    throw new Error(error.response?.data?.error || "Error registering entry");
  }
}

export async function updateOrderStatus(id, status) {
  try {
    let response = await api.patch(`/orders/${id}/status`, {
      status,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating order status:", error.response?.data?.error);
    throw new Error(
      error.response?.data?.error || "Error updating order status"
    );
  }
}

export async function registrarEntrega(id) {
  // atualiza o status do pedido pra entregue
  try {
    let response = await updateOrderStatus(id, "entregue");
    return response;
  } catch (error) {
    console.error("Error registering delivery:", error.response?.data?.error);
    throw new Error(
      error.response?.data?.error || "Error registering delivery"
    );
  }
}
